import { Nullable } from "@logex/framework/types";
import {
    LgFormattingSymbolMetadata,
    ILgFormatterOptions,
    IParseResult,
    ILgFormatter
} from "./formatter-types";
import { parse } from "./number-helpers/parse";
import { format } from "./number-helpers/format";
import { formatForEditing } from "./number-helpers/formatForEditing";

const DefaultOptions: ILgFormatterOptions = {
    decimals: 2,
    viewScale: 2,
    forceSign: false,
    forceFormat: true
};

const FormattingSymbol: LgFormattingSymbolMetadata = {
    symbol: "%",
    separator: String.fromCharCode(8239),
    removeRegex: /\s*%$/,
    position: "after"
};

export class PercentageFormatter implements ILgFormatter<number> {
    names = ["percent", "percentage"];

    private _symbol = FormattingSymbol;

    constructor(
        public options: ILgFormatterOptions,
        private _locale: string
    ) {
        this.options = { ...DefaultOptions, ...this.options };
    }

    parse(val: string, options?: ILgFormatterOptions): IParseResult<number> {
        val = val.replace(this._symbol.removeRegex, "");

        const { decimals, viewScale } = { ...this.options, ...options };
        return parse(val, decimals, viewScale);
    }

    format(val: Nullable<number>, options?: ILgFormatterOptions): string {
        const result = format(val, this._locale, { ...this.options, ...options });

        return this._decorateWithSymbol(result, this._symbol, result === "−");
    }

    formatForEditing(val: Nullable<number>, options?: ILgFormatterOptions): string {
        if (val == null || "" + val === "") {
            return "";
        }

        return formatForEditing(val, this._locale, { ...this.options, ...options });
    }

    private _decorateWithSymbol(
        val: string,
        formattingSymbol: LgFormattingSymbolMetadata,
        isDash: boolean
    ): string {
        return isDash ? val : val + formattingSymbol.separator + formattingSymbol.symbol;
    }
}
